import { IFilterOptions } from '@quadminds/shared/commons';

export interface IGetStateDefinitionsFiltersDto extends IFilterOptions {
    includeExternal?: boolean;
    includeSharedFinished?: boolean;
}
